export default __webpack_public_path__ + "static/media/plus.263c9ad0.svg";